import styled from 'styled-components';
import {device} from './responsives';

export const Section = styled.div`
  float: left;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  @media ${device.mobileL}{
    width: 70%;
  }
`

export const Header = styled.div`
  width: 100%;
  margin: 24px 16px 0px;
  padding: 0px;
  text-align: right;
  height: 50px;
  @media ${device.maxlaptop}{
    text-align: left;
    margin: 24px 0px 0px;
  }
`

export const Image = styled.img`
  max-height: 40px;
  max-width: 40px;
  object-fit: contain;
  margin: 0px 30px 0px 8px;
  float: right;
  @media ${device.maxLaptop}{
    float: left;
    width: auto;
    margin: 0px 30px 0px 0px;
  }
`

export const EndImage = styled(Image)`
  height: 48px;
  width: 48px;
  margin-right: 32px;
`

export const Title = styled.h3`
  font-family: Avenir;
  font-size: 28px;
  font-weight: 800;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  margin: 0px;
  float: left;

  @media ${device.mobileL}{
    font-size: 18px;
    width: 100%;
  }
`

export const Dash = styled.div`
  grid-row-start: 1;
  grid-row-end: auto;
  border-left: 2px dashed #4a4a4a;
  height: 100%;
  margin: 0 auto;
  width: 2px;

  @media ${device.mobileL}{
    display: none;

  }
`
